if (!customElements.get('studies-filter-ttt')) {
  class StudiesFilterTtt extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-filter-type]'));
      this.items = Array.from(this.querySelectorAll('[data-study-type]'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });
    }

    select(activeButton) {
      const type = activeButton.dataset.filterType;

      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', button === activeButton ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        item.hidden = type !== '' && item.dataset.studyType !== type;
      });
    }
  }

  customElements.define('studies-filter-ttt', StudiesFilterTtt);
}
